import { Text, Stack } from "@mantine/core";
import { TemplateDownloadSectionComponentProps } from "./types";

export function TemplateDownloadSectionComponent(
  props: TemplateDownloadSectionComponentProps
) {
  const { action } = props;

  function generateUrl(action: string) {
    if (action === "create") {
      return "https://res.cloudinary.com/monosolusi/raw/upload/v1684310327/Mazuta/mazuta_create_transaction_vcrlgs.csv";
    } else if (action === "delete") {
      throw new Error("Invalid action");
    } else throw new Error("Invalid action");
  }

  return (
    <Stack>
      <Text>Please download the template by clicking the link below</Text>
      <Text
        component="a"
        href={generateUrl(action)}
        target="_blank"
        color="primary"
      >
        Download Import CSV Template
      </Text>
    </Stack>
  );
}
